module.exports = __webpack_public_path__ + "img/pic__photo_07@2x.4e13568e.png";